jQuery( document ).ready(function() {

    // Initialize Tiny Slider
    jQuery(".tiny-slider.tiny-slider-testimonials").each(function() {
        var sliderId = jQuery(this).data('slider');
        var currentSlider = jQuery('.tiny-slider.tiny-slider-testimonials.'+sliderId).parents('.testimonials-container');
        var photoGallerySlider = tns({
            container: '.tiny-slider.tiny-slider-testimonials.'+sliderId,
            items: 1,
            slideBy: 'page',
            autoplay: true,
            mouseDrag: true,
            controls: true,
            nav: true,
            navPosition: 'bottom',
            controlsText: ['<span class="arrow-icon-left"></span>', '<span class="arrow-icon-right"></span>'],
        });
    });
});